import "babel-polyfill";
import "core-js";
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  console.log = function () { } // Disabling console.log in production
}

// (function () {
//   const origLog = console.log;

//   function safeStringify(value) {
//     try {
//       if (typeof value === "string") return value;
//       return JSON.stringify(value, getCircularReplacer(), 2);
//     } catch (e) {
//       // Last-chance fallback if stringify still fails
//       return String(value);
//     }
//   }

//   function getCircularReplacer() {
//     const seen = new WeakSet();
//     return function (key, value) {
//       if (typeof value === "object" && value !== null) {
//         if (seen.has(value)) return "[Circular]";
//         seen.add(value);
//       }
//       return value;
//     };
//   }

//   console.log = function (...args) {
//     const msg = args.map(safeStringify).join(" ");
//     origLog.call(console, msg);
//   };
// })();


platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err)); 
